import React, {useEffect} from "react";
import {ArrowSort20Filled as SortIcon} from "@fluentui/react-icons"
import styles from "./List.module.css";


interface ListProps extends React.ComponentPropsWithoutRef<"div"> {
    children?: React.ReactNode;
}

interface ListHeaderProps {
    title?: string;
    children?: React.ReactNode;
}

export const ListHeader = ({title, children}: ListHeaderProps) => {
    return <div className={styles.header}>
        <span className={styles.headerText}>{title}</span>
        {children}
    </div>
}

export const List = ({children, ...rest}: ListProps) => {
    if (!Array.isArray(children))
        children = [children];
    
    const childrenArray = [...children].flat(1);

    let listHeader: React.ReactNode;
    const listChildren: React.ReactElement[] = [];
    for (let child of childrenArray)
        if (child.type && child.type == 'li' && child.key && child.props?.children)
            listChildren.push(
                <li key={child.key} className={`${child.className} ${styles.listItem}`}>
                    {child.props.children}
                </li>);
        else if (child.type.name === 'ListHeader' || child.type === ListHeader){
            listHeader = child;
        }
        
    return <div {...rest}>
        {listHeader && listHeader}
        <ul className={styles.listContainer}>
            {listChildren}
        </ul>
    </div>
}

export default List;